import { Toast, parseErrors } from 'helpers';
import { postJobSendSms, putTaskSendSms } from 'queries';
import { useMutation } from '@tanstack/react-query';
import { JsonDataItem } from 'types';

function useSendSms(onSuccess?: () => void) {
  const {
    mutate: sendTaskSms,
    isLoading: isTasksSmsSending,
    isSuccess: isTaskSmsSent,
  } = useMutation(putTaskSendSms, {
    onSuccess,
    onError: (error: JsonDataItem) => {
      Toast.show({ description: parseErrors(error).join(', '), type: Toast.Type.Error });
    },
  });

  const {
    mutate: sendJobSms,
    isLoading: isJobSmsSending,
    isSuccess: isJobSmsSent,
  } = useMutation(postJobSendSms, {
    onSuccess,
    onError: (error: JsonDataItem) => {
      Toast.show({ description: parseErrors(error).join(', '), type: Toast.Type.Error });
    },
  });

  return {
    sendTaskSms,
    sendJobSms,
    isSending: isTasksSmsSending || isJobSmsSending,
    isSmsSent: isJobSmsSent || isTaskSmsSent,
  };
}

export { useSendSms };
